<template>
  <v-app>
    <TopBar v-if="$route.path != '/' && $route.name != 'Not found'"/>
    <router-view></router-view>
    <SnackBar />
    <Loading />
  </v-app>
  </template>

<script>
import TopBar from "./components/layout/TopBar"
import SnackBar from "./components/utils/SnackBar"
import Loading from "./components/utils/Loading"
export default {
  components: {
    TopBar,
    SnackBar,
    Loading
  }
}
</script>
